module.exports = require('whatwg-fetch');
